/// <reference path="DOMAttached.js" />

class PopupOpener extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		this.safeObserve(this.el, 'click', this.onClick.bind(this));
		this.url = document.getElementById(el).href;
	}

	onClick(e) {
		this.popup = window.open(this.url, "", "scrollbars=1");
		this.popup.resizeTo(this.options.Width, this.options.Height);

		if (this.options.adjustHeightToContent !== undefined && this.options.adjustHeightToContent) {
			this.safeObserve(this.popup, 'load', this.onLoad.bind(this));
		}
		e.preventDefault();
		e.stopPropagation();
	}

	onLoad() {
		this.headerHeight = this.options.Height - this.popup.document.documentElement.clientHeight;
		this.contentHeight = this.popup.document.body.clientHeight;
		this.popup.resizeTo(this.options.Width, this.headerHeight + this.contentHeight);
	}
}
